import React, { useEffect } from 'react'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import {
  DEFAULT_PATH,
  SEARCH_PATIENT_PATH,
  TIMELINE_GENERAL_PATH,
  TIMELINE_LABORATORY_PATH,
  TIMELINE_MATERNAL_INFANT_PATH,
  TIMELINE_RADIOLOGY_PATH,
  DIAGNOSES_PATH,
  ALLERGIES_PATH,
  ANALYTICAL_MODELS_PATH,
  FETAL_DIAGNOSES_PATH,
  TIMELINE_ONCOLOGY_PATH
} from '~/constants'
import {
  Dashboard,
  LaboratoryMedicalView,
  MaternalInfantMedicalView,
  GeneralMedicalView,
  RadiologyMedicalView,
  Diagnoses,
  FetalDiagnoses,
  Allergies,
  AnalyticalModels
} from '~/pages'
import { App } from '~/App'
import { SearchPatient } from '~/components/patient/searchPatient'
import { useLastSelectedMedicalView } from '~/context'
import { OncologyMedicalView } from '~/pages/oncologyMedicalView'

export const Redirect: React.FC<{ to: string }> = ({ to }) => {
  const navigate = useNavigate()
  useEffect(() => {
    navigate(to)
  })
  return null
}

export const RouterThree: React.FC = () => {
  const location = useLocation()

  const { updateLastSelectedMedicalView } = useLastSelectedMedicalView()

  useEffect(() => {
    updateLastSelectedMedicalView(location.pathname)
  }, [location, updateLastSelectedMedicalView])

  return (
    <Routes key={location.pathname} location={location}>
      <Route path={`/${DEFAULT_PATH}`} element={<App />}>
        <Route index element={<Redirect to={SEARCH_PATIENT_PATH} />} />
        <Route path={SEARCH_PATIENT_PATH} element={<SearchPatient />} />
        <Route element={<Dashboard />}>
          <Route path={`${TIMELINE_GENERAL_PATH}`} element={<GeneralMedicalView />} />
          <Route path={`${TIMELINE_GENERAL_PATH}/:medicalRecord`} element={<GeneralMedicalView />} />
          <Route path={`${TIMELINE_LABORATORY_PATH}/:medicalRecord`} element={<LaboratoryMedicalView />} />
          <Route path={`${TIMELINE_MATERNAL_INFANT_PATH}/:medicalRecord`} element={<MaternalInfantMedicalView />} />
          <Route path={`${TIMELINE_RADIOLOGY_PATH}/:medicalRecord`} element={<RadiologyMedicalView />} />
          <Route path={`${TIMELINE_ONCOLOGY_PATH}/:medicalRecord`} element={<OncologyMedicalView />} />

          <Route path={`${DIAGNOSES_PATH}/:medicalRecord`} element={<Diagnoses />} />
          <Route path={`${FETAL_DIAGNOSES_PATH}/:medicalRecord`} element={<FetalDiagnoses />} />
          <Route path={`${ALLERGIES_PATH}/:medicalRecord`} element={<Allergies />} />
          <Route path={`${ANALYTICAL_MODELS_PATH}/:medicalRecord`} element={<AnalyticalModels />} />
        </Route>
      </Route>
      <Route path="*" element={<Redirect to={`/${DEFAULT_PATH}/${SEARCH_PATIENT_PATH}`} />} />
    </Routes>
  )
}
